import { cva } from 'class-variance-authority';

// Adapted from shadcn/ui's Base UI button. Mio keeps its existing public variants.
export const buttonVariants = cva(
  'ui-button inline-flex max-w-full shrink-0 items-center justify-center gap-2 whitespace-normal rounded-md border text-center font-semibold leading-5 transition-[background,color,border-color,box-shadow] outline-none select-none focus-visible:ring-2 focus-visible:ring-ring/25 focus-visible:border-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        primary: 'border-transparent bg-primary text-primary-fg hover:bg-primary-hover',
        secondary: 'border-line-strong bg-canvas text-fg hover:border-fg-muted hover:bg-surface',
        ghost: 'border-transparent text-fg-muted hover:bg-surface hover:text-fg',
        danger: 'border-danger/25 bg-danger-soft text-danger hover:bg-danger/15',
      },
      size: {
        md: 'min-h-10 px-4 py-2 text-sm',
        sm: 'min-h-8 px-3 py-1 text-sm',
        icon: 'size-9 p-0 text-sm',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
);
